export default __webpack_public_path__ + "static/media/Snd_2_Starts.b9fc43d0.mp3";